export default "__VITE_ASSET__7530c89a__"